import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { HOME_PAGE, TINH_NANG, VINAPHONE_PLUS } from 'global/routes';
import logo_vnpt from 'assets/imgs/logo_home.png';
import flag_VN from 'assets/imgs/flag-vn.png';
import flag_UK from 'assets/imgs/flag-uk.png';
import mail from 'assets/imgs/mail.png';
import carretDown from 'assets/imgs/carret-down.png';
import carretRight from 'assets/imgs/carret-right.png';
import { UserService } from 'services/UserService';
import { FormattedMessage } from 'react-intl';
import { Button, InputSearch, Notification, OutsideClick } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import Search from './Component/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/fontawesome-free-solid';
import { Link, useHistory } from 'react-router-dom';
import Login from 'pages/Login/Login';
import { doGetMsisdn, doGetUserInfoLoyalty, doGetUserInfoVplus, doGetUserPromoMenu, doLoginLoyalty, doLoginVplus, doLogout, doLogoutLoyalty, doLogoutVplus, doTokenDevVplus, doTokenHoiVienEscVplus, doTokenHoiVienVplus } from 'store/action/userAction';
import { changeLocale } from 'store/action/languageAction';
import { Modal } from 'antd';
import { shield_lock_icon } from 'assets/icons/VinaphonePlus';
import MembershipCardModalVplus from 'pages/VinaphonePlusNew/Pages/VNPlusHomePage/components/VNPLusHomeTopBannerLogin/components/MembershipCardModalVplus/MembershipCardModalVplus';
import { SELFCARE } from 'global/environment';
import ModalVPlusRegister from './Component/ModalVPlusRegister/ModalVPlusRegister';

const PATH = [
  '/tinh-nang',
  '/ekyc',
  VINAPHONE_PLUS
]

const LIST_TITLE = [
  {
    title: 'IDS_HOME_PAGE',
    url: '/',
  },
  {
    title: 'IDS_TV_GOI_CUOC',
    url: '/dich-vu',
    menuList: [
      { name: 'IDS_TV_GOIDIDONG', href: '/dich-vu/goi-cuoc-di-dong' },
      { name: 'IDS_HOME_COMBO', href: '/dich-vu/home-combo' },
      { name: 'IDS_HOME_INTERNET', href: '/dich-vu/home-internet' },
      { name: 'IDS_HOME_TV', href: '/dich-vu/home-tv' },
      // { name: 'IDS_TV_GOIMYTV', href: '/dich-vu/mytv' },
      { name: 'IDS_TV_GOIMYTV_OTT', href: '/dich-vu/mytv-ott' },
      { name: 'IDS_TV_GTGT', href: '/dich-vu/gtgt' },
      { name: 'IDS_TVCODINH', href: '/dich-vu/co-dinh' },
      { name: 'IDS_TV_GOI_FAMILY', href: '/dich-vu/gia-dinh-van-phong' },
      // { name: 'IDS_DIGILIFE_PACKAGE', href: '/dich-vu/digilife' },
    ]
  },
  {
    title: 'IDS_TV_HO_TRO_KHACH_HANG',
    url: '/tinh-nang/gui-yeu-cau',
    menuList: [
      { name: 'IDS_ELECTRICINVOICE', href: "/tinh-nang/hoa-don-dien-tu" },
      { name: 'IDS_SHELPGUIYEUCAU', href: "/tinh-nang/gui-yeu-cau" },
      { name: 'IDS_REFLECT_SERVICE_QUALITY', href: "/tinh-nang/phan-anh-chat-luong" },
      { name: 'IDS_SHELPYEUCAUDAGUI', href: "/tinh-nang/yeu-cau-da-gui" },
      { name: 'IDS_TV_DIA_DIEM_STORE', href: "/tinh-nang/dia-diem-cua-hang" },
      { name: 'IDS_TV_DANG_KY_DOI_SIM', href: "/tinh-nang/dang-ky-doi-sim-4g" },
      { name: 'IDS_TV_DK_SIM_TT', href: "/tinh-nang/dang-ky-sim" },
      { name: 'IDS_FAQ', href: "/tinh-nang/hoi-dap" },
      { name: 'IDS_TV_DK_DK', href: "/tinh-nang/dieu-khoan-su-dung" },
      { name: 'IDS_TV_DK_CSBVDL', href: "/tinh-nang/chinh-sach-rieng-tu" },
      { name: 'IDS_TV_SMART_TV_SUPPORT', href: "/tinh-nang/smart-tv-ho-tro-mytv" },
      { name: 'IDS_MANAGE_MULTISIM', href: "/tinh-nang/quan-ly-multisim" },
      // { name: 'IDS_TV_DOI_SIM_EZCOM', href: "/tinh-nang/doi-sim-ezcom" },
      { name: 'IDS_APP', href: "/tinh-nang/ung-dung" },
    ]
  },
];

export const LIST_VNPP_TITLE_LOGOUT = [
  {
    title: 'IDS_VINAPHONE_PLUS',
    url: '/vinaphone-plus',
    menuList: [
      { name: 'IDS_MENBER_INFO', href: '/', canOpenLogin: true },
      { name: 'IDS_PROMOTION_PROGRAM', href: '/', canOpenLogin: true },
      { name: 'IDS_ABOUT_VINAPHONE_PLUS', href: '/vinaphone-plus/about' },
      { name: 'IDS_VINAPHONE_PLUS_PARTNERS', href: '/vinaphone-plus/about?key=becomePartner' }
    ]
  },
];

const LIST_FEATURE = [
  { title: 'IDS_TV_QLTK_GOI_CUOC', url: `${TINH_NANG}/thong-tin-ca-nhan` },
  { title: 'IDS_MANAGER_INTERNET_MYTV', url: `${TINH_NANG}/quan-ly-home-internet` },
  { title: 'IDS_TV_HIS', url: `${TINH_NANG}/lich-su-su-dung` },
  { title: 'IDS_TV_CHANGE_PASS', url: `${TINH_NANG}/doi-mat-khau` },
  { title: 'IDS_TV_HO_TRO_KHACH_HANG', url: `${TINH_NANG}/hoi-dap` },
  { title: 'IDS_TV_THANH_TOAN', url: `${TINH_NANG}/thanh-toan-dich-vu` },
  { title: 'IDS_NEWS_PROMOTION', url: `${TINH_NANG}/tin-tuc` },
]

// const TitleItem = ({ title, menuList, url, authorized }) => (
//   <div className="header__item-wrapper">
//     <Link to={url}>
//       <span><FormattedMessage id={title} /></span>
//       {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
//     </Link>
//     {menuList &&
//       <ul className="header__dropdown-menu">
//         {menuList.map((item, index) => (
//           <React.Fragment key={index}>
//             {(authorized || (item.name !== 'IDS_MANAGE_MULTISIM' && item.name !== 'IDS_TV_DOI_SIM_EZCOM')) &&
//               <li><Link to={item.href}><FormattedMessage id={item.name} /></Link></li>
//             }
//           </React.Fragment>
//         ))}
//       </ul>
//     }
//   </div>
// );

const TitleItem = ({ title, menuList, url, authorized, setOpenModalLogin, handleVPlusCheckRegister, vplus_userInfo, setIsModalMemberCard }) => (
  <div className="header__item-wrapper">
    {!localStorage.getItem('flowType') &&
      <Link to={url}>
        <span><FormattedMessage id={title} /></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
      </Link>
    }
    {localStorage?.getItem("flowType") === "Vplus" && !vplus_userInfo &&
      <Link to={url}>
        <span><FormattedMessage id={title}/></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2"/>}
      </Link>
    }
    {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ERRORCODE !== "ERR-COD-90001" &&
      <Link to={url}>
        <span><FormattedMessage id={title} /></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
      </Link>
    }
    {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ERRORCODE === "ERR-COD-90001" && title !== 'IDS_VINAPHONE_PLUS' &&
      <Link to={url}>
        <span><FormattedMessage id={title} /></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
      </Link>
    }
    {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ERRORCODE === "ERR-COD-90001" && title === 'IDS_VINAPHONE_PLUS' &&
      <div className='item-wrapper-with-action' onClick={() => handleVPlusCheckRegister()}>
        <span><FormattedMessage id={title}/></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2"/>}
      </div>
    }
    {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") == "0" &&
        <Link to={url}>
          <span><FormattedMessage id={title}/></span>
          {menuList && <img src={carretDown} alt="icon" className="ml-2"/>}
        </Link>
    }
    {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") != "0" && title !== 'IDS_VINAPHONE_PLUS' &&
      <Link to={url}>
        <span><FormattedMessage id={title} /></span>
        {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
      </Link>
    }
    {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") != "0" && title === 'IDS_VINAPHONE_PLUS' &&
        <div className='item-wrapper-with-action' onClick={() => handleVPlusCheckRegister()}>
          <span><FormattedMessage id={title}/></span>
          {menuList && <img src={carretDown} alt="icon" className="ml-2"/>}
        </div>
    }
    {authorized && menuList && <SubMenu menuList={menuList} authorized={authorized} level={0} handleVPlusCheckRegister={handleVPlusCheckRegister} vplus_userInfo={vplus_userInfo} setIsModalMemberCard={setIsModalMemberCard} />}
    {!authorized && menuList && <SubMenu menuList={menuList} authorized={authorized} level={0} setOpenModalLogin={setOpenModalLogin} handleVPlusCheckRegister={handleVPlusCheckRegister} vplus_userInfo={vplus_userInfo} setIsModalMemberCard={setIsModalMemberCard} />}
  </div>
);

const SubMenu = ({ menuList, authorized, level = 0, setOpenModalLogin, handleVPlusCheckRegister, vplus_userInfo, setIsModalMemberCard }) => {
  return (
    <ul className={`${level > 0 ? 'header__sub-dropdown-menu' : 'header__dropdown-menu'}`}>
      {menuList.map((item, index) => (
        <li key={index} className={item.subMenuList ? 'has-submenu' : ''}>
          {(authorized || (item.name !== 'IDS_MANAGE_MULTISIM' && item.name !== 'IDS_TV_DOI_SIM_EZCOM')) && (
            <>
              {item.canOpenLogin === true &&
                <>
                  {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ERRORCODE === "ERR-COD-90001" &&
                    <div className='item-with-action' onClick={() => handleVPlusCheckRegister()}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  }
                  {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ErrorCode === 200 &&
                    <div className='item-with-action' onClick={() => setOpenModalLogin(true)}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  }
                  {!localStorage?.getItem("flowType") &&
                    <div className='item-with-action' onClick={() => setOpenModalLogin(true)}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  }

                  {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") != "0" &&
                    <div className='item-with-action' onClick={() => handleVPlusCheckRegister()}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  }
                  {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") == "0" &&
                    <div className='item-with-action' onClick={() => setOpenModalLogin(true)}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  }
                  {/* {localStorage?.getItem("flowType") === "Loyalty" && !vplus_userInfo &&
                    <div className='item-with-action' onClick={() => setOpenModalLogin(true)}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </div>
                  } */}
                </>
              }
              {item.canOpenLogin !== true &&
                <>
                  {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ERRORCODE === "ERR-COD-90001" &&
                    <Link to={item.href}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </Link>
                  }
                  {localStorage?.getItem("flowType") === "Vplus" && !vplus_userInfo &&
                    <>
                      {item.canOpenMeminfo === true &&
                        <div className='item-with-action' onClick={() => setIsModalMemberCard(true)}>
                          <span><FormattedMessage id={item.name}/></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2"/>}
                        </div>
                      }
                      {item.canOpenMeminfo !== true &&
                        <Link to={item.href}>
                          <span><FormattedMessage id={item.name}/></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2"/>}
                        </Link>
                      }
                    </>
                  }
                  {localStorage?.getItem("flowType") === "Vplus" && vplus_userInfo && vplus_userInfo?.ErrorCode === 200 &&
                    <>
                      {item.canOpenMeminfo === true &&
                        <div className='item-with-action' onClick={() => setIsModalMemberCard(true)}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </div>
                      }
                      {item.canOpenMeminfo !== true &&
                        <Link to={item.href}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </Link>
                      }
                    </>
                  }
                  {!localStorage?.getItem("flowType") &&
                    <>
                      {item.canOpenMeminfo === true &&
                        <div className='item-with-action' onClick={() => setIsModalMemberCard(true)}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </div>
                      }
                      {item.canOpenMeminfo !== true &&
                        <Link to={item.href}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </Link>
                      }
                    </>
                  }

                  {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") != "0" &&
                    <Link to={item.href}>
                      <span><FormattedMessage id={item.name} /></span>
                      {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                    </Link>
                  }
                  {localStorage?.getItem("flowType") === "Loyalty" && localStorage?.getItem("loyaltyErrorCode") == "0" &&
                    <>
                      {item.canOpenMeminfo === true &&
                        <div className='item-with-action' onClick={() => setIsModalMemberCard(true)}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </div>
                      }
                      {item.canOpenMeminfo !== true &&
                        <Link to={item.href}>
                          <span><FormattedMessage id={item.name} /></span>
                          {item.subMenuList && <img src={carretRight} alt="icon" className="ml-2" />}
                        </Link>
                      }
                    </>
                  }
                </>
              }
            </>
          )}
          {item.subMenuList && <SubMenu menuList={item.subMenuList} authorized={authorized} level={level + 1} setIsModalMemberCard={setIsModalMemberCard} />}
        </li>
      ))}
    </ul>
  );
};

const Header = () => {
  const [isOpenModalLogin, setOpenModalLogin] = useState(false);
  const [isOpenModalVplusWarning, setOpenModalVplusWarning] = useState(false);
  const [isModalMemberCard, setIsModalMemberCard] = useState(false)
  const [fixedHeader, setFixedHeader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [valueSearch, setValueSearch] = useState('');
  const [listVNPPTitle, setListVNPPTitle] = useState(LIST_VNPP_TITLE_LOGOUT);
  const authorizedVplusState = useSelector(state => state.authorizedVplusReducer);
  const [vplus_userInfo, setVplus_userInfo] = useState(useSelector(state => state.authorizedVplusReducer.vplus_userInfo));

  const authorizedLoyaltyState = useSelector(state => state.authorizedLoyaltyReducer);
  // const [loyalty_userInfo, setLoyalty_userInfo] = useState(useSelector(state => state.authorizedLoyaltyReducer.loyalty_userInfo));
  const [loyalty_userInfo, setLoyalty_userInfo] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [isOpenModalVplusRegister, setIsOpenModalVplusRegister] = useState(false);
  // const [showMenu, setShowMenu] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const authorized = useSelector(state => state.authorizedReducer.authorized);
  const locale = useSelector(state => state.language.locale);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fixedHeader]);

  useEffect(() => {
    if (localStorage.getItem('vplus_promoMenu')) {
      const vplus_promoMenu = JSON.parse(localStorage.getItem('vplus_promoMenu'))
      setListVNPPTitle(vplus_promoMenu)
    }
    if (localStorage?.getItem("flowType") === "Vplus" && !authorizedVplusState.vplus_userInfo && localStorage.getItem('vplus_userInfo')) {
      const vplus_userInfo = JSON.parse(localStorage.getItem('vplus_userInfo'));

      if (vplus_userInfo?.ERRORCODE === "ERR-COD-90001") {
        dispatch(doLogoutVplus());
      } else {
        dispatch(doLoginVplus());
      }
      dispatch(doTokenDevVplus(localStorage.getItem('vplus_TokenDev')));
      dispatch(doTokenHoiVienEscVplus(localStorage.getItem('vplus_TokenHoiVienEsc')));
      dispatch(doTokenHoiVienVplus(localStorage.getItem('vplus_TokenHoiVien')));
      dispatch(doGetUserInfoVplus(JSON.parse(localStorage.getItem('vplus_userInfo'))));
      const vplus_promoMenu = JSON.parse(localStorage.getItem('vplus_promoMenu'));
      dispatch(doGetUserPromoMenu(vplus_promoMenu));
    } else {
      dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
    }
    if (authorized && localStorage.getItem('mobile')) {
      dispatch(doGetMsisdn(localStorage.getItem('mobile')));
    }

    if (localStorage?.getItem("flowType") === "Loyalty" && !authorizedLoyaltyState.loyalty_userInfo) {
      if (localStorage?.getItem("loyaltyErrorCode") != "0") {
        dispatch(doLogoutLoyalty());
      } else {
        dispatch(doLoginLoyalty());
      }
      dispatch(doGetUserInfoLoyalty(JSON.parse(localStorage.getItem('loyalty_userInfo'))));
      const vplus_promoMenu = JSON.parse(localStorage.getItem('vplus_promoMenu'));
      dispatch(doGetUserPromoMenu(vplus_promoMenu));
    } else {
      dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
    }
  }, [])

  useEffect(() => {
    if (localStorage?.getItem("flowType") === "Loyalty") {
      let data;
      if (localStorage?.getItem("loyalty_userInfo")) {
        data = JSON?.parse(localStorage?.getItem("loyalty_userInfo"));
      } else {
        data = authorizedLoyaltyState?.loyalty_userInfo;
      }
      setUserInfo(data?.userInfo);

      let userInfo = {
        fullName: data?.customerInfo?.fullName,
        dateOfBirth: data?.customerInfo?.dateOfBirth,
        gender: data?.customerInfo?.gender,
        // identifierType: data?.customerInfo?.identifierType,
        identifierType: "CCCD",
        identifier: data?.customerInfo?.identifier,
        identifierIssuedDate: data?.customerInfo?.identifierIssuedDate,
        identifierIssuedPlace: data?.customerInfo?.identifierIssuedPlace,
        email: data?.customerInfo?.emailLoyalty,
        provinceId: data?.customerInfo?.provinceId,
        districtId: data?.customerInfo?.districtId,
        wardId: data?.customerInfo?.wardId,
        address: data?.customerInfo?.address
      };
      setLoyalty_userInfo(userInfo);

    } else if (localStorage?.getItem("flowType") === "Vplus") {
      if (localStorage.getItem('vplus_userInfo')) {
        setVplus_userInfo(JSON.parse(localStorage.getItem('vplus_userInfo')))
      } else {
        setVplus_userInfo(authorizedVplusState.vplus_userInfo)
      }
    }
  }, [authorizedVplusState, authorizedLoyaltyState])

  useEffect(() => {
    if (localStorage.getItem('vplus_promoMenu')) {
      setListVNPPTitle(JSON.parse(localStorage.getItem('vplus_promoMenu')))
    } else {
      setListVNPPTitle(authorizedVplusState.vplus_promoMenu)
    }
  }, [authorizedVplusState.vplus_promoMenu])

  const handleOpenVplusNotMemberWarning = () => {
    setOpenModalVplusWarning(false);
    if (window.location.pathname.includes('/vinaphone-plus')) {
      window.location.assign('/');
    }
  }

  const handleScroll = () => {
    const sticky = document.documentElement.scrollTop;
    if (sticky > 50) {
      setFixedHeader(true);
    } else if (fixedHeader && sticky === 0) {
      setFixedHeader(false);
    }
  }

  const handleLogOut = () => {
    const data = {
      msisdn: localStorage.getItem('mobile'),
    };

    UserService.logout(data, res => {
      if (res.error_code === '0') {
        dispatch(doLogout());
        dispatch(doLogoutVplus());
        localStorage.clear();
        dispatch(doTokenDevVplus(""));
        dispatch(doTokenHoiVienEscVplus(""));
        dispatch(doTokenHoiVienVplus(""));
        dispatch(doGetUserInfoVplus(undefined));
        dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));

        dispatch(doLogoutLoyalty());
        dispatch(doGetUserInfoLoyalty(undefined));
        Notification.success("Đăng xuất thành công");

        const found = PATH.some(item => history.location.pathname?.includes(item)); // check url contain pathname
        setListVNPPTitle(LIST_VNPP_TITLE_LOGOUT)
        if (found) {
          history.push('/');
        }
      } else {
        Notification.error("Có lỗi xảy ra!");
      }
    }, () => {
      Notification.error("Có lỗi xảy ra!");
    });
  }

  const handleChange = value => {
    localStorage.setItem('language', value);
    dispatch(changeLocale(value));
  };

  const handleOnSearch = () => {
    if (valueSearch?.trim() === '') {
      return;
    }
    const search = valueSearch.replace(/\s|%/g, "+");
    history.push(`/tim-kiem/${search}`);
    setValueSearch('');
  }

  const handleVPlusCheckRegister = () => {
    if (localStorage?.getItem("flowType") === "Loyalty") {
      if (localStorage?.getItem("loyaltyErrorCode") == "26") {
        setOpenModalVplusWarning(true);
      } else if (localStorage?.getItem("loyaltyErrorCode") != "0" && localStorage?.getItem("loyaltyErrorCode") != "26") {
        setIsOpenModalVplusRegister(true);
      }

    } else if (localStorage?.getItem("flowType") === "Vplus") {
      if (vplus_userInfo?.ERRORCODE === "ERR-COD-90001") {
        if (vplus_userInfo?.customerOfVinaphone === 1) {
          setIsOpenModalVplusRegister(true);
        } else {
          setOpenModalVplusWarning(true);
        }
      }
    }
  }

  return (
    <>
      <div className={`header-wrapper-top ${fixedHeader ? 'height-0' : ''}`}>
        <div className="container header-top d-none d-md-flex">
          <div className="header-top__left">
            <p><FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' />: <a href="tel:18001091">18001091</a></p>
            <p><FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' />: <a href="tel:18001166">18001166</a></p>
            <p className="display-center">
              <img alt="img" src={mail} />
              <span className="ml-2">cskh@vnpt.vn</span>
            </p>
          </div>

          <div className='d-flex header-top__end'>
            <div className='selfcare'>
              <a className='active' href='/' onClick={(e) => { e.preventDefault() }} >Cá nhân</a>
            </div>
            <div className='selfcare'>
              <a href={SELFCARE}>Doanh nghiệp</a>
            </div>

            {locale === 'vi' &&
              <div className="header-top__flag" onClick={() => handleChange('en-US')}>
                <img alt="flag" src={flag_UK} />
                <span className="ml-3">English</span>
              </div>
            }
            {locale === 'en-US' &&
              <div className="header-top__flag" onClick={() => handleChange('vi')}>
                <img alt="flag" src={flag_VN} />
                <span className="ml-3">Việt Nam</span>
              </div>
            }
          </div>

        </div>

        <div className="container header-top d-md-none">
          <p><FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' />: 18001091</p>
          <p><FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' />: 18001166</p>

          <div className="display-center">
            <div className="header-top__mail">
              <img alt="img" src={mail} />
              <span className="ml-2">cskh@vnpt.vn</span>
            </div>

            {locale === 'vi' &&
              <div className="header-top__flag" onClick={() => handleChange('en-US')}>
                <img alt="flag" src={flag_UK} />
                <span className="ml-3">English</span>
              </div>
            }
            {locale === 'en-US' &&
              <div className="header-top__flag" onClick={() => handleChange('vi')}>
                <img alt="flag" src={flag_VN} />
                <span className="ml-3">Việt Nam</span>
              </div>
            }
          </div>
        </div>
      </div>

      <div className={`header-wrapper ${fixedHeader ? 'sticky' : ''}`}>
        <div className={`container header ${openMenu ? 'open-menu' : ''}`}>
          <div className="d-flex">
            <Link to={HOME_PAGE}>
              <img alt="home" src={logo_vnpt} className='header__icon-home' />
            </Link>
            {/* <img alt="noel" src={noel2} className='header__icon-noel1 d-none d-md-block' />
            <img alt="noel" src={noel1} className='header__icon-noel2 d-md-none' /> */}
          </div>


          <div className="d-none d-lg-block">
            <div className="display-sb">
              {LIST_TITLE.map((item, index) => (
                <TitleItem
                  key={index}
                  title={item.title}
                  menuList={item.menuList}
                  url={item.url}
                  authorized={authorized}
                />
              ))}
              {listVNPPTitle?.map((item, index) => (
                <TitleItem
                  key={index}
                  title={item.title}
                  menuList={item.menuList}
                  url={item.url}
                  authorized={authorized}
                  isOpenModalLogin={isOpenModalLogin}
                  setOpenModalLogin={setOpenModalLogin}
                  handleVPlusCheckRegister={handleVPlusCheckRegister}
                  vplus_userInfo={vplus_userInfo}
                  setIsModalMemberCard={setIsModalMemberCard}
                />
              ))}

              {authorized &&
                <div className="header__item-wrapper">
                  <p><FormattedMessage id='IDS_HELLO' /> {`0${localStorage.getItem('mobile')?.slice(2)}`}</p>
                </div>
              }
              {!authorized &&
                <div className="header__item-wrapper" onClick={() => setOpenModalLogin(true)}>
                  <p><FormattedMessage id='IDS_TV_SIGN_IN' /></p>
                </div>
              }
              {authorized &&
                <div className="header__feature header__item-wrapper">
                  <div className="header__close-btn feature-btn">
                    <span style={{ opacity: 0 }}>VNPT</span>
                    <div />
                  </div>

                  <ul className="header__dropdown-menu">
                    {LIST_FEATURE.map((item, index) => (
                      <li key={index}>
                        <FontAwesomeIcon color="#000" icon={faCaretRight} size="1x" className="mr-3" />
                        <Link to={item.url}><FormattedMessage id={item.title} /></Link>
                      </li>
                    ))}
                    <li className="header__item-wrapper" onClick={handleLogOut}>
                      <FontAwesomeIcon color="#000" icon={faCaretRight} size="1x" className="mr-3" />
                      <span><FormattedMessage id='IDS_TV_SIGN_OUT' /></span>
                    </li>
                  </ul>
                </div>
              }

              <Search
                valueSearch={valueSearch}
                setValueSearch={setValueSearch}
                onEnter={handleOnSearch}
                clickOutSide={() => setValueSearch('')}
              />
            </div>
          </div>


          <div className="d-lg-none">
            <div className="d-flex">
              <InputSearch
                value={valueSearch}
                handleOnChange={(value) => setValueSearch(value)}
              />
              <OutsideClick onClickOutSide={() => setOpenMenu(false)}>
                <div className="header__close-btn" onClick={() => setOpenMenu(!openMenu)}>
                  <div />
                </div>

                <div className="header__menu-dropdown">
                  {LIST_TITLE.map((item, index) => (
                    <TitleItem
                      key={index}
                      title={item.title}
                      menuList={item.menuList}
                      url={item.url}
                      authorized={authorized}
                    />
                  ))}

                  {listVNPPTitle?.map((item, index) => (
                    <TitleItem
                      key={index}
                      title={item.title}
                      menuList={item.menuList}
                      url={item.url}
                      authorized={authorized}
                      isOpenModalLogin={isOpenModalLogin}
                      setOpenModalLogin={setOpenModalLogin}
                      handleVPlusCheckRegister={handleVPlusCheckRegister}
                      vplus_userInfo={vplus_userInfo}
                      setIsModalMemberCard={setIsModalMemberCard}
                    />
                  ))}
                  {authorized &&
                    <div className="header__item-wrapper">
                      <p>
                        <span><FormattedMessage id='IDS_FEATURE' /></span>
                        <img src={carretDown} alt="icon" className="ml-2" />
                      </p>

                      <ul className="header__dropdown-menu">
                        {LIST_FEATURE.map((item, index) => (
                          <li key={index}>
                            <Link to={item.url}><FormattedMessage id={item.title} /></Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  }

                  {/* <div className="header__item-wrapper"> */}
                    {/* <a href="https://vinaphoneplus.com.vn/" target="_blank" rel="noopener noreferrer">
                      <span><FormattedMessage id='IDS_VINAPHONE_PLUS' /></span>
                    </a> */}
                    {/* <a href={VINAPHONE_PLUS} rel="noopener noreferrer">
                      <span><FormattedMessage id='IDS_VINAPHONE_PLUS' /></span>
                    </a>
                  </div> */}

                  {authorized &&
                    <div className="header__item-wrapper" onClick={handleLogOut}>
                      <p><FormattedMessage id='IDS_TV_SIGN_OUT' /></p>
                    </div>
                  }
                  {!authorized &&
                    <div className="header__item-wrapper" onClick={() => setOpenModalLogin(true)}>
                      <p><FormattedMessage id='IDS_TV_SIGN_IN' /></p>
                    </div>
                  }
                </div>
              </OutsideClick>
            </div>
          </div>
        </div>

        {isOpenModalLogin &&
          <Login
            isOpenModalLogin={isOpenModalLogin}
            closeModalLogin={() => setOpenModalLogin(false)}
            setListVNPPTitle={setListVNPPTitle}
            listVNPPTitle={listVNPPTitle}
            setOpenModalVplusWarning={setOpenModalVplusWarning}
          />
        }

        <Modal className='modal-vplus-warning' title="Thông báo" visible={isOpenModalVplusWarning} onCancel={() => handleOpenVplusNotMemberWarning()} footer={null} >
          <p>Bạn chưa phải là hội viên VinaPhone Plus. Vui lòng liên hệ tổng đài <a href='tel://18001091'>18001091</a> để được tư vấn và hỗ trợ</p>
          <Button onClick={() => handleOpenVplusNotMemberWarning()}>
            <img src={shield_lock_icon} /> Tôi đã hiểu
          </Button>
        </Modal>

        {authorized &&
          <MembershipCardModalVplus
            isVisible={isModalMemberCard}
            handleOk={() => setIsModalMemberCard(false)}
            handleCancel={() => setIsModalMemberCard(false)}
            userInfo={localStorage?.getItem("flowType") === "Loyalty" ? userInfo : (localStorage?.getItem("flowType") === "Vplus" ? vplus_userInfo?.ThongTinHoiVien : null)}
            phoneNumber={localStorage.getItem('mobile') ? `0${localStorage.getItem('mobile')?.slice(2)}` : ''}
          />
        }

        <ModalVPlusRegister
          isOpen={isOpenModalVplusRegister}
          onCancel={() => setIsOpenModalVplusRegister(false)}
          customerInfo={localStorage?.getItem("flowType") === "Loyalty" ? loyalty_userInfo : vplus_userInfo?.customerInfo}
        />
      </div>
    </>
  );
};

export default React.memo(Header);
